module.exports = __webpack_public_path__ + "img/HOLDING.27da2f9c.png";